import React, {useState} from "react"
import clsx from "clsx"
import debounce from "debounce"
import {FormControl, FormLabel} from "@chakra-ui/react"
import {Combobox} from "@headlessui/react"
import {MagnifyingGlassIcon} from "@heroicons/react/24/outline"
import {Option} from "@components/form"

type AutoCompleteProps = {
    label?: string,
    placeholder?: string,
    defaultValues?: ResultProps[]
    onSearch: (searchText: string) => Promise<ResultProps[]>,
    onSelect: (value: Option) => any
    className?: string
}

export type ResultProps = Option & {
    element: React.ReactNode,
    data: any
}

const onSearchDebounce = debounce((val, onSearch, cb) => {

    if (!val)
        return cb([])

    onSearch(val)
        .then(results => {
            cb(results)
        })
}, 200)

export function AutoComplete({label, placeholder, defaultValues, onSearch, onSelect, className}: AutoCompleteProps) {
    const [results, setResults] = useState<ResultProps[]>(defaultValues || [])
    const [query, setQuery] = useState<string>("")

    return <FormControl className={className}>
        {label &&
          <FormLabel>{label}</FormLabel>}
        <Combobox value={query}
                  onChange={(val) => {
                      setQuery("")
                      // @ts-ignore
                      onSelect(val)
                  }}>
            <div className="relative">
                <MagnifyingGlassIcon
                    className="pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                />
                <Combobox.Input
                    className="h-12 w-full pl-11 pr-4 text-gray-800 placeholder-gray-400 focus:ring-0 sm:text-sm rounded"
                    placeholder={placeholder || "Search..."}
                    style={{border: "1px solid #e2e8f0"}}
                    onChange={(event) => {
                        const val = event.target.value
                        setQuery(val)
                        onSearchDebounce(val, onSearch, setResults)
                    }}
                />
            </div>

            {results.length > 0 && (
                <Combobox.Options
                    className="max-h-72 scroll-py-2 overflow-y-auto py-2 text-sm text-gray-800 border">
                    {results.map((loc) => (
                        <Combobox.Option
                            key={loc.value}
                            value={loc}
                            className={({active}) =>
                                clsx("cursor-default select-none px-4 py-2", active && "bg-indigo-600 text-white")
                            }
                        >
                            {loc.element}
                        </Combobox.Option>
                    ))}
                </Combobox.Options>
            )}
        </Combobox>
    </FormControl>
}